import { getBackOfficeProxy } from './index';
import { defaultPostHeaderForJsonData } from '@inwink/apibase';

export interface IContent {
    id: string;
    title: any;
    publishedAt: string;
    herobanner?: {
        thumbUrl?: string;
        thumbSmallUrl?: string;
        thumbLargeUrl?: string;
        url?: string;
        type?: string;
    }
    thumbnail?: {
        thumbUrl?: string;
        thumbSmallUrl?: string;
        thumbLargeUrl?: string;
        url?: string;
        type?: string;
    }
}

export interface IArticle extends IContent{
    
}

export interface IWEvent extends IContent {
    startDate: string;
    endDate: string;
}

export interface IVod extends IContent {
    
}

export interface IDocument extends IContent {
    
}

export function getMemberStatus() : Promise<any>{
    return getBackOfficeProxy().getJson(`inwinkconnect/memberinfo`);
}

export function getArticlesCount(query?: any) : Promise<number>{
    return getBackOfficeProxy().postJson(
        `inwinkconnect/articles/count`, query ? JSON.stringify(query) : "{}", defaultPostHeaderForJsonData);
}

export function getArticles(query?: any) : Promise<IArticle[]>{
    return getBackOfficeProxy().postJson(
        `inwinkconnect/articles/query`, query ? JSON.stringify(query) : "{}", defaultPostHeaderForJsonData);
}

export function getEventsCount(query?: any) : Promise<number>{
    return getBackOfficeProxy().postJson(
        `inwinkconnect/iwevents/count`, query ? JSON.stringify(query) : "{}", defaultPostHeaderForJsonData);
}

export function getEvents(query?: any) : Promise<IWEvent[]>{
    return getBackOfficeProxy().postJson(
        `inwinkconnect/iwevents/query`, query ? JSON.stringify(query) : "{}", defaultPostHeaderForJsonData);
}

export function getVodsCount(query?: any) : Promise<number>{
    return getBackOfficeProxy().postJson(
        `inwinkconnect/vods/count`, query ? JSON.stringify(query) : "{}", defaultPostHeaderForJsonData);
}

export function getVods(query?: any) : Promise<IVod[]>{
    return getBackOfficeProxy().postJson(
        `inwinkconnect/vods/query`, query ? JSON.stringify(query) : "{}", defaultPostHeaderForJsonData);
}

export function getDocumentsCount(query?: any) : Promise<number>{
    return getBackOfficeProxy().postJson(
        `inwinkconnect/documents/count`, query ? JSON.stringify(query) : "{}", defaultPostHeaderForJsonData);
}

export function getDocuments(query?: any) : Promise<IDocument[]>{
    return getBackOfficeProxy().postJson(
        `inwinkconnect/documents/query`, query ? JSON.stringify(query) : "{}", defaultPostHeaderForJsonData);
}